<!-- alert 컴포넌트..!
    
-->
<template>
    <button class="gmx_button" :class="'type_'+cl" @click="changeMap" :style="style" >
       <slot name="body"></slot>
       {{ title }}
    </button>
</template>

<script setup> 

import { defineProps } from 'vue';

defineProps({
    title : {
      type:String,
    },
    cl : {
        type:String,
        default : ''
    },
    style : {
        type:Object
    }
});

</script>

<style lang="scss" scoped> /* 이 파일에만 적용되는 스타일 */

    .gmx_button {
        flex: none;
        font-size: 14px;
        + .gmx_button {
            margin-left: 10px;
        }
        &.type_a {
            width: 100%;
            background-color: $gmx-main-color;
            border-radius: $border-radius1;
            color: #ffffff;
            font-size: $font-size4;
            &:hover {
                background-color: $gmx-main-color;
            }
        }
        &.type_b {
        color: $gmx-font-sub-color;
        font-size: $font-size1;
        background: $gmx-theme-color;
            &:hover {
                color: $gmx-font-sub-color2;
            }
        }
        &.type_c {
            
            background-repeat: no-repeat;
            background-position: center;
            font-size : $font-size6;
        }
        &.type_d {
            background: $gmx-theme-color;
            height: 34px;
            box-sizing: border-box;
            padding: 0 15px;
            border: 1px solid $gmx-box-sub-br-color;
            border-radius: $border-radius1;
            font-size: $font-size1;
            &:hover {
                background-color: $gmx-box-bg-color;
            }
        }
        &.type_e {
            background: $gmx-theme-color;
            height: 34px;
            box-sizing: border-box;
            padding: 0 15px;
            border: 1px solid $gmx-main-color;
            border-radius: $border-radius1;
            font-size: $font-size1;
            color: $gmx-main-color;
            &:hover {
                background-color: $gmx-main-color;
                color: $gmx-theme-color;
            }
        }

        &.type_f {
            width : 60px;
            height: 40px;
            margin-top:20px;
            box-sizing: border-box;
            padding: 0 15px;
            border: 1px solid $gmx-main-color;
            border-radius: $border-radius1;
            background-color: $gmx-main-color;
            font-size: $font-size3;
            color: $gmx-theme-color;
            &:hover {
                background-color: $gmx-main-color;
                color: $gmx-theme-color;
            }
        }
    }

</style>